// extracted by mini-css-extract-plugin
export default {"depositPointsTable":"DepositPointsList_depositPointsTable__c95XS"};